import { InAppState } from "../base/InAppState";
import '../../components/apitoken/api-token-list';
import template from './ApiTokenTemplate.html';

export class ApiTokenState extends InAppState
{
    static ROUTE = '/api-tokens';
    static ID = 'admin-api-tokens';

    async enter()
    {
        this.app.view.render(
            this.app.view.pageContent,
            template,
            {}
        );

        const apiTokenList = this.app.view.pageContent.querySelector( 'api-token-list' );
        if ( apiTokenList )
        {
            apiTokenList.loadTokens();
        }
    }

    async exit()
    {
    }

    getContentHeaderData()
    {
        return {
            title: 'API Tokens',
            breadcrumb: [ 'Admin', 'API Tokens' ]
        };
    }
}
